<div class="empresa-dc">
  <div class="empresa-dc-hero">
    <img
      [src]="imgBanner"
      width="707"
      height="217"
      alt="Nuestro data center propio en Chile"
      loading="lazy" />
  </div>

  <article class="empresa-dc-block empresa-dc-block--infra">
    <div class="empresa-dc-copy">
      <h3>Nuestro data center</h3>
      <p>
        Nuestro Data Center Propio a sido instalado con los más altos estandares , contamos con enlace de fibra optica, grupo electrogeno de respaldo, sistema de refrigeración redundante, ups para todos nuestros servidores, balanceo de cargas redundantes además de velocidad nacional de 1 GB.
      </p>
    </div>
    <div class="empresa-dc-media">
      <img
        [src]="imgServidores"
        width="169"
        height="180"
        alt="Racks con servidores Dell en nuestro data center"
        loading="lazy" />
    </div>
  </article>

  <mat-divider class="empresa-dc-divider"></mat-divider>

  <article class="empresa-dc-block empresa-dc-block--seguridad">
    <div class="empresa-dc-copy">
      <h3>Seguridad</h3>
      <p>
        Nuestro Data Center esta equipado con un conjunto de equipos de seguridad, gestión de alimentación eléctrica, climatización y acceso restringido con camara de seguridad. Además todos nuestros servidores poseen sistema de redundancia de alimentación eléctrica y un grupo electrogeno de respaldo.
      </p>
    </div>
    <div class="empresa-dc-media">
      <img
        [src]="imgGenerador"
        width="169"
        height="180"
        alt="Grupo electrógeno de respaldo para continuidad operativa"
        loading="lazy" />
    </div>
  </article>

  <mat-divider class="empresa-dc-divider"></mat-divider>

  <article class="empresa-dc-block empresa-dc-block--electricidad">
    <div class="empresa-dc-copy">
      <h3>Electricidad redundante</h3>
      <p>
        Un servidor no solo debe tener un suministro constante de energía si no que además debe tener una garantía de que esta llegue de manera constante y que no sufra de subidas y bajadas bruscas para evitar daños. Es por esto que tenemos las UPS que son baterias que se conectan entre los servidores y la fuente de suministro eléctrico, además tenemos generadores que se conectan entre las UPS y la fuente de suministro eléctrico, estos se ponen en marcha en el caso que se corte el suministro de energía.
      </p>
    </div>
    <div class="empresa-dc-media">
      <img
        [src]="imgUps"
        width="169"
        height="180"
        alt="Unidades Eaton y panel de control: alimentación redundante"
        loading="lazy" />
    </div>
  </article>
</div>
